import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  ButtonToolbar,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import {
  REPORT_PARAMETERS,
  REPORT_TYPES,
} from '../../../shared/utils/constants';
import { generateReport, openReport } from '../../../shared/utils/smartutils';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';

function PrintSchoolIdModal(props) {
  const { title, toggle, modal, t, students, dispatch } = props;
  const [selectedType, setSelectedType] = useState('1');

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const useStyles = makeStyles(() => ({
    SchoolCards: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
    },
  }));

  const classes = useStyles();

  const onChangeCardType = (type) => {
    setSelectedType(type);
  };

  const onPrintHandler = () => {
    let studentsId;

    if (students.length) {
      studentsId = students.map((item) => item.id);
    } else {
      studentsId = students.id;
    }

    const formData = new FormData();
    if (selectedType === '1') {
      formData.append(REPORT_PARAMETERS.REPORTTYPE, REPORT_TYPES.RELA_CARTAO);
      formData.append(REPORT_PARAMETERS.pCO00TITU, studentsId);
      formData.append(REPORT_PARAMETERS.pISQRCODE, 0);
    }

    if (selectedType === '2') {
      formData.append(REPORT_PARAMETERS.REPORTTYPE, REPORT_TYPES.RELA_CARTAO);
      formData.append(REPORT_PARAMETERS.pCO00TITU, studentsId);
      formData.append(REPORT_PARAMETERS.pISQRCODE, 1);
    }

    if (selectedType === '3') {
      formData.append(REPORT_PARAMETERS.REPORTTYPE, REPORT_TYPES.RELA_CRACHA);
      formData.append(REPORT_PARAMETERS.pCO00TITU, studentsId);
      formData.append(REPORT_PARAMETERS.pISQRCODE, 0);
    }

    if (selectedType === '4') {
      formData.append(REPORT_PARAMETERS.REPORTTYPE, REPORT_TYPES.RELA_CRACHA);
      formData.append(REPORT_PARAMETERS.pISQRCODE, 1);
      formData.append(REPORT_PARAMETERS.pCO00TITU, studentsId);
    }

    showLoading();
    generateReport(formData)
      .then(async (res) => {
        openReport(res.data);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('report.error-generate')
        );
      });

    toggle();
  };

  const onClosedHandler = () => {
    setSelectedType('1');
  };

  return (
    <div>
      <Modal
        isOpen={modal}
        toggle={toggle}
        onClosed={onClosedHandler}
        className="theme-light"
      >
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>
          <Label component="legend">
            {t('screens.mnt_alunos.selectCardTemplate')}
          </Label>

          <FormControl component="fieldset">
            <RadioGroup
              aria-label="position"
              name="position"
              className={classes.SchoolCards}
              onChange={(event, value) => onChangeCardType(value)}
              value={selectedType}
            >
              <FormControlLabel
                value="1"
                control={<Radio color="#646777" />}
                label={
                  <img
                    src="https://smartsistemasinteligentes.com.br/smartapi/files/1511e6fad067cb37fe6fc2bf80261ed236773226f67367382f"
                    alt={t('screens.mnt_alunos.tooltips.cardBarCode')}
                    title={t('screens.mnt_alunos.tooltips.cardBarCode')}
                  />
                }
                labelPlacement="top"
              />
              <FormControlLabel
                value="2"
                control={<Radio color="#646777" />}
                label={
                  <img
                    src="https://smartsistemasinteligentes.com.br/smartapi/files/99758a1b22ebefc92b79ec592655c10efa98fa16c54a980c32"
                    alt={t('screens.mnt_alunos.cardQRCode')}
                    title={t('screens.mnt_alunos.tooltips.cardQRCode')}
                  />
                }
                labelPlacement="top"
              />
              <FormControlLabel
                value="3"
                control={<Radio color="#646777" />}
                label={
                  <img
                    src="https://smartsistemasinteligentes.com.br/smartapi/files/474f27f7883b22d4600c22551d96c5d120cc324f8659aee082"
                    alt={t('screens.mnt_alunos.badgeBarCode')}
                    title={t('screens.mnt_alunos.tooltips.badgeBarCode')}
                  />
                }
                labelPlacement="top"
              />
              <FormControlLabel
                value="4"
                control={<Radio color="#646777" />}
                label={
                  <img
                    src="https://smartsistemasinteligentes.com.br/smartapi/files/a66df7657957104b7f2e5f89595b9cbdb95f1d4134573274d1"
                    alt={t('screens.mnt_alunos.badgeQRCode')}
                    title={t('screens.mnt_alunos.tooltips.badgeQRCode')}
                  />
                }
                labelPlacement="top"
              />
            </RadioGroup>
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <ButtonToolbar>
            <Button color="success" onClick={onPrintHandler}>
              {t('general.print')}
            </Button>
          </ButtonToolbar>
        </ModalFooter>
      </Modal>
    </div>
  );
}

PrintSchoolIdModal.propTypes = {
  title: PropTypes.string,
  toggle: PropTypes.func.isRequired,
  modal: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  students: PropTypes.oneOfType([
    PropTypes.shape(PropTypes.shape),
    PropTypes.arrayOf(PropTypes.shape),
  ]).isRequired,
};

PrintSchoolIdModal.defaultProps = {
  title: '',
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(PrintSchoolIdModal)
);
